export default __webpack_public_path__ + "static/media/gift1.075f7fdb.svg";